import { render, staticRenderFns } from "./kslabelManagement.vue?vue&type=template&id=ab8e3eca&scoped=true&"
import script from "./kslabelManagement.vue?vue&type=script&lang=js&"
export * from "./kslabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./kslabelManagement.vue?vue&type=style&index=0&id=ab8e3eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8e3eca",
  null
  
)

export default component.exports